"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInstallManagementService = void 0;
class IInstallManagementService {
    constructor(eventStream) {
        this.eventStream = eventStream;
    }
}
exports.IInstallManagementService = IInstallManagementService;
//# sourceMappingURL=IInstallManagementService.js.map